import React from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center text-gray-500 dark:text-gray-400">
      <h3 className="text-base font-medium">{title}</h3>
      {description && <p className="mt-1 text-sm">{description}</p>}
    </div>
  );
};
